
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { PaymentHistoryLoading } from "./LoadingStates";

interface Payment {
  id: string;
  amount: number;
  discount: number;
  paid_at: string;
  description?: string;
  payment_method?: string | null;
}

interface PaymentHistoryProps {
  payments: Payment[];
  isLoading?: boolean;
}

export const PaymentHistory = ({ payments, isLoading }: PaymentHistoryProps) => {
  if (isLoading) {
    return <PaymentHistoryLoading />;
  }

  return (
    <div className="bg-primary/10 dark:bg-white/5 ocean:bg-blue-800/20 sunset:bg-orange-800/20 forest:bg-green-800/20 backdrop-blur-lg rounded-xl p-6 border border-black/10 dark:border-white/10 payment-history">
      <h3 className="text-xl font-heading mb-4 text-foreground">Historial de Pagos</h3>
      <div className="space-y-4">
        {payments?.map((payment) => (
          <div
            key={payment.id}
            className="flex justify-between items-center p-4 bg-black/5 dark:bg-white/5 ocean:bg-blue-700/10 sunset:bg-orange-700/10 forest:bg-green-700/10 rounded-lg border border-black/10 dark:border-white/10"
          >
            <div>
              <p className="font-medium text-foreground capitalize">
                {format(new Date(payment.paid_at), "MMMM yyyy", { locale: es })}
              </p>
              <p className="text-sm text-foreground/70">
                Pagado el {format(new Date(payment.paid_at), "dd/MM/yyyy")}
              </p>
              {(payment.description || payment.payment_method) && (
                <div className="flex flex-wrap gap-1 mt-1">
                  {payment.description?.split(', ').map((category, index) => (
                    <span 
                      key={index}
                      className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-primary/20 text-primary"
                    >
                      {category}
                    </span>
                  ))}
                  {payment.payment_method && (
                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-secondary text-secondary-foreground border border-border">
                      {payment.payment_method}
                    </span>
                  )}
                </div>
              )}
            </div>
            <div className="text-right">
              <span className="text-green-600 dark:text-green-400">${payment.amount}</span>
              {payment.discount > 0 && (
                <p className="text-sm text-foreground/60">
                  Descuento: ${payment.discount}
                </p>
              )}
            </div>
          </div>
        ))}
        {(!payments || payments.length === 0) && (
          <p className="text-center text-foreground/60">No hay pagos registrados</p>
        )}
      </div>
    </div>
  );
};
